import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdSettingsFallbackRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-settings-fallback',
	path: '/servicedesk/admin/:projectKey/:adminOption',
};
